import XssSanitizerService from '@/services/xssSanitizer';

/**
 * Vue directive for XSS protection
 * Usage: v-safe-html="content"
 * Modifiers:
 * - .trust (trust that content is already sanitized)
 * - .sanitize (full sanitization - default behavior)
 * - .rich (rich text sanitization)
 * - .simple (simple text sanitization)
 * - .escape (complete HTML escape)
 */
export default {
  install (Vue) {
    Vue.directive('safe-html', {
      bind (el, binding) {
        const { value, modifiers } = binding;

        // Determine sanitization method based on modifiers
        let sanitizedContent = '';

        if (modifiers.trust) {
          // Trust that content is already sanitized, just do light sanitization
          sanitizedContent = XssSanitizerService.renderSafely(value, true);
        } else if (modifiers.rich) {
          sanitizedContent = XssSanitizerService.sanitizeRichText(value);
        } else if (modifiers.simple) {
          sanitizedContent = XssSanitizerService.sanitizeSimpleText(value);
        } else if (modifiers.escape) {
          sanitizedContent = XssSanitizerService.escapeHtmlWithLineBreaks(value);
        } else {
          // Default: full sanitization (same as .sanitize)
          sanitizedContent = XssSanitizerService.sanitize(value);
        }

        el.innerHTML = sanitizedContent;
      },

      update (el, binding) {
        const { value, modifiers } = binding;

        let sanitizedContent = '';

        if (modifiers.trust) {
          sanitizedContent = XssSanitizerService.renderSafely(value, true);
        } else if (modifiers.rich) {
          sanitizedContent = XssSanitizerService.sanitizeRichText(value);
        } else if (modifiers.simple) {
          sanitizedContent = XssSanitizerService.sanitizeSimpleText(value);
        } else if (modifiers.escape) {
          sanitizedContent = XssSanitizerService.escapeHtmlWithLineBreaks(value);
        } else {
          // Default: full sanitization (same as .sanitize)
          sanitizedContent = XssSanitizerService.sanitize(value);
        }

        el.innerHTML = sanitizedContent;
      },
    });
  },
};
